import React from 'react';
import styles from "./Ordertransactions.module.scss";
import { useNavigate } from 'react-router-dom';
import StatusBadge from '../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';
import DynamicDatatable from '../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import { transactionInsightsTableData } from '../../../../views/AdminPortal/dummyData';

const TransactionsInsightsComp = ({ setDetails }) => {
    const navigate = useNavigate();



    const ampleOptions = [
        { label: "View detail", action: () => setDetails() },
        { label: "Edit", action: () => console.log("Activate Product") },
        { label: "Delete", action: () => console.log("Notify Seller") },
        { label: "Change Status", action: () => console.log("Notify Seller") },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Period",
            selector: (row) => row.period,
            center: "true",
            width: "150px",
        },
        {
            name: "Total Transactions",
            selector: (row) => row.totalTrans,
            center: "true",
            width: "150px",
        },
        {
            name: "Total Revenue",
            cell: (row) => <StatusBadge revenue={true} statusName={row.totalRevenue} />,
            center: "true",
        },
        {
            name: "Refunds Processed",
            selector: (row) => row.refunds,
            center: "true",
        },
        {
            name: "Failed Transactions",
            selector: (row) => row.failedTrans,
            center: "true",
        },
        {
            name: "Action",
            cell: (row) => <ActionButton options={ampleOptions} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={transactionInsightsTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default TransactionsInsightsComp;